<template>
    <section class="quote light pink">
        <circles-layout></circles-layout>

        <v-quote>Ik merk dat de docenten en directeuren het waardevol vinden om met ons te spreken; wij bevinden ons onder de studenten en weten dus wat er speelt.</v-quote>

        <v-author>– Ilse de Leeuw, student en voorzitter van de Centrale Studentenraad</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'OnderwijskwaliteitQuote',
        meta: {
            title: 'Onderwijskwaliteit',
            color: '#fe1362'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
